import {
  FiBookOpen,
  FiBriefcase,
  FiInbox,
  FiSend,
  FiUser,
} from 'react-icons/fi';
import { LuBrainCircuit, LuRadar } from 'react-icons/lu';

// Shared navigation definition for the seeker workspace.
// Grouping mirrors the employer app pattern while using job-seeker specific product areas.
export const NAVIGATION_SECTIONS = [
  {
    labelKey: 'navigation.sections.discover',
    items: [
      {
        key: 'opportunities',
        labelKey: 'navigation.items.opportunities',
        to: '/opportunities',
        icon: FiBriefcase,
        matchers: ['/opportunities', '/job/', '/apply/'],
      },
      {
        key: 'inbox',
        labelKey: 'navigation.items.inbox',
        to: '/inbox',
        icon: FiInbox,
        matchers: ['/inbox'],
      },
      {
        key: 'outreach',
        labelKey: 'navigation.items.outreach',
        to: '/outreach',
        icon: FiSend,
        matchers: ['/outreach'],
      },
    ],
  },
  {
    labelKey: 'navigation.sections.grow',
    items: [
      {
        key: 'career-coach',
        labelKey: 'navigation.items.careerCoach',
        to: '/career-coach',
        icon: LuBrainCircuit,
        matchers: ['/career-coach', '/career-paths', '/mock-interview', '/ask-anything', '/configure-scout'],
      },
      {
        key: 'company-radar',
        labelKey: 'navigation.items.companyRadar',
        to: '/company-radar',
        icon: LuRadar,
        matchers: ['/company-radar'],
      },
      {
        key: 'learning-pathways',
        labelKey: 'navigation.items.learningPathways',
        to: '/learning-pathways',
        icon: FiBookOpen,
        matchers: ['/learning-pathways'],
      },
    ],
  },
  {
    labelKey: 'navigation.sections.you',
    items: [
      {
        key: 'profile',
        labelKey: 'navigation.items.profile',
        to: '/profile',
        icon: FiUser,
        matchers: ['/profile', '/settings'],
      },
    ],
  },
];

export const PAGE_META = {
  opportunities: {
    eyebrowKey: 'navigation.meta.discover',
    titleKey: 'navigation.items.opportunities',
    descriptionKey: 'navigation.descriptions.opportunities',
  },
  inbox: {
    eyebrowKey: 'navigation.meta.discover',
    titleKey: 'navigation.items.inbox',
    descriptionKey: 'navigation.descriptions.inbox',
  },
  outreach: {
    eyebrowKey: 'navigation.meta.discover',
    titleKey: 'navigation.items.outreach',
    descriptionKey: 'navigation.descriptions.outreach',
  },
  'career-coach': {
    eyebrowKey: 'navigation.meta.grow',
    titleKey: 'navigation.items.careerCoach',
    descriptionKey: 'navigation.descriptions.careerCoach',
  },
  'company-radar': {
    eyebrowKey: 'navigation.meta.grow',
    titleKey: 'navigation.items.companyRadar',
    descriptionKey: 'navigation.descriptions.companyRadar',
  },
  'learning-pathways': {
    eyebrowKey: 'navigation.meta.grow',
    titleKey: 'navigation.items.learningPathways',
    descriptionKey: 'navigation.descriptions.learningPathways',
  },
  profile: {
    eyebrowKey: 'navigation.meta.profile',
    titleKey: 'navigation.items.profile',
    descriptionKey: 'navigation.descriptions.profile',
  },
};

export function getActivePageKey(pathname) {
  for (const section of NAVIGATION_SECTIONS) {
    for (const item of section.items) {
      if (item.matchers.some((matcher) => pathname.startsWith(matcher))) {
        return item.key;
      }
    }
  }

  return 'opportunities';
}
